module.exports = __webpack_public_path__ + "static/media/sakirt.f9b74889.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/sakirt.png
// module id = 240
// module chunks = 0